import { render } from "./CustomKpiDeleteDialog.vue?vue&type=template&id=072a24f1"
import script from "./CustomKpiDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./CustomKpiDeleteDialog.vue?vue&type=script&lang=ts"
script.render = render

export default script